<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-arrow-right3'
  }
})
</script>

<template>
  <nuxt-link class="link">
    <div class="link__icon">
      <svg-icon :name="props.icon" />
    </div>
    <div class="link__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  display: inline-flex;
  align-items: center;

  &__icon {
    width: toRem(24);
    height: toRem(24);
    color: $color-brand-3;
    margin-right: toRem(6);
  }

  &__title {
    font-size: toRem(16);
    line-height: 1.45;
    color: $color-gray-1;
  }

  &.not-bound {
    .link__icon {
      color: $color-gray-3;
    }
  }
}
</style>
